export const formatDate = (inputDate, showYear) => {
    if (inputDate !== null && inputDate !== "") {
        const dateParts = inputDate.split('-');
        const day = dateParts[2];
        const month = dateParts[1];
        const year = dateParts[0];

        return `${day}.${month}.${showYear ? year : ""}`;
    } else return ""
}